export const getCurrTime = () => Math.round(Date.now());
